// REST client for Microsoft Foundry integrations, one per Entra tenant.
import { idForPath, restDelete, restGet, restPatch, restPost } from "./restClient.js";

const ROOT = "/v1/microsoft-foundry-integrations";

export function listMicrosoftFoundryIntegrations({ signal } = {}) {
    return restGet(ROOT, null, { signal });
}

// A managed connection may name its Entra tenant, as a GUID or a domain: a tenant this
// Origin tenant already consented for its directory or Copilot connection then connects at
// once, and any other waits for admin consent.
export function createMicrosoftFoundryIntegration({ managed = false, entraTenantId = "", clientId, clientSecret }) {
    return restPost(
        ROOT,
        managed
            ? { managed: true, entra_tenant_id: entraTenantId }
            : {
                  managed: false,
                  entra_tenant_id: entraTenantId,
                  client_id: clientId,
                  client_secret: clientSecret,
              },
    );
}

export function addMicrosoftFoundryWorkspaces(integrationId, workspaceResourceIds) {
    return restPatch(`${ROOT}/${idForPath(integrationId)}`, { add_workspace_resource_ids: workspaceResourceIds });
}

export function removeMicrosoftFoundryWorkspace(integrationId, workspaceResourceId) {
    return restPatch(`${ROOT}/${idForPath(integrationId)}`, { remove_workspace_resource_ids: [workspaceResourceId] });
}

// An empty client id keeps the stored one.
export function replaceMicrosoftFoundrySecret(integrationId, { clientId = "", clientSecret }) {
    return restPatch(`${ROOT}/${idForPath(integrationId)}`, { client_id: clientId, client_secret: clientSecret });
}

export function deleteMicrosoftFoundryIntegration(integrationId) {
    return restDelete(`${ROOT}/${idForPath(integrationId)}`);
}

export function getMicrosoftFoundryAuthUrl({ integrationId, redirectUri, code = "", state = "" }) {
    return restPost(`${ROOT}:auth-url`, {
        integration_id: integrationId,
        redirect_uri: redirectUri,
        code,
        state,
    });
}

export function completeMicrosoftFoundryAdminConsent({ integrationId, state, adminConsent, tenant }) {
    return restPost(`${ROOT}:complete-consent`, {
        integration_id: integrationId,
        admin_consent: adminConsent,
        tenant_id: tenant,
        state,
    });
}
